export const twoDigitsNum = (num) => ("0" + num).slice(-2);
